// @flow

export const PIT_STATS_REQUEST = 'Pit/PIT_STATS_REQUEST';
export const PIT_STATS_SUCCESS = 'Pit/PIT_STATS_SUCCESS';
export const PIT_STATS_FAILURE = 'Pit/PIT_STATS_FAILURE';
export const PIT_STATS_RESET = 'Pit/PIT_STATS_RESET';
